<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Política de Cookies</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Política de Cookies</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="terms-conditions ptb-100">
    <div class="container">
        <div class="single-privacy">
            <h2>enCloud®</h2>
            <p><strong>Última actualización:</strong> 12 de Noviembre del 2024</p>
            <p>En enCloud®, nuestra prioridad es la transparencia y la protección de la privacidad de nuestros usuarios.
                Esta política explica cómo usamos cookies y tecnologías similares en nuestro sitio web y plataformas,
                además de cómo puedes gestionar tus preferencias.</p>

            <h3>1. ¿Qué son las cookies?</h3>
            <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio
                web. Estas cookies ayudan a que el sitio web funcione de manera eficiente y permiten que proporcionemos
                servicios personalizados, mejorando tu experiencia de usuario.
            </p>

            <h3>2. Tipos de cookies que utilizamos</h3>
            <p>
                En enCloud® utilizamos diferentes tipos de cookies para distintos propósitos:

            </p>
            <ul>
                <li><strong>Cookies necesarias:</strong> Estas cookies son esenciales para que nuestro sitio funcione.
                    Permiten la navegación segura y el uso de las funciones básicas de nuestra plataforma.</li>
                <li><strong>Cookies de rendimiento:</strong> Recopilan información sobre cómo los usuarios interactúan
                    con nuestro sitio. Esto nos ayuda a mejorar el rendimiento y la funcionalidad de nuestras páginas.
                </li>
                <li><strong>Cookies de funcionalidad:</strong> Estas cookies permiten que recordemos tus preferencias,
                    como idioma y configuraciones personalizadas, para ofrecerte una experiencia más cómoda y
                    personalizada.</li>
                <li><strong>Cookies de marketing y análisis:</strong> Nos ayudan a entender mejor tus intereses y
                    mostrarte contenido relevante. También permiten medir la efectividad de nuestras campañas
                    publicitarias.</li>
            </ul>
            <h3>3. ¿Para qué utilizamos las cookies?</h3>
            <p>
                En enCloud®, utilizamos cookies para:

            </p>
            <ul>
                <li>Ofrecer un acceso seguro y eficiente a nuestros servicios de cómputo en la nube, alojamiento de
                    datos y servidores.</li>
                <li>Recordar tus preferencias para mejorar tu experiencia de usuario.</li>
                <li>Analizar y optimizar la interacción en nuestra web y así personalizar el contenido.</li>
                <li>Ofrecerte publicidad y recomendaciones de servicios que se ajusten a tus necesidades, incluyendo
                    almacenamiento de datos y procesamiento masivo de información, hosting de servidores gaming y
                    machine learning.</li>

            </ul>

            <h3>4. ¿Qué tecnologías similares utilizamos?</h3>
            <p>
                Además de cookies, enCloud® puede usar tecnologías similares como balizas web y etiquetas de píxeles
                para recopilar datos adicionales sobre tu navegación en nuestro sitio y medir la efectividad de nuestras
                campañas en distintas plataformas.

            </p>

            <h3>5. ¿Cómo puedes gestionar las cookies?</h3>
            <p>
                Puedes ajustar las configuraciones de tu navegador para aceptar, rechazar o borrar cookies. Ten en
                cuenta que deshabilitar algunas cookies podría afectar el funcionamiento del sitio y limitar el acceso a
                ciertas funcionalidades de enCloud®.
                Para más información sobre la configuración de cookies en tu navegador, visita las guías de ayuda
                específicas:


            </p>
            <ul>
                <li> <a target="_blank" href="https://support.google.com/chrome/answer/95647"><strong>Google Chrome</strong></a>
                </li>
                <li> <a target="_blank"
                        href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">
                        <strong>Mozilla Firefox</strong></a> </li>
                <li><a target="_blank" href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"><strong>Safari</strong></a></li>
                <li><a target="_blank" href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"><strong>Microsoft Edge</strong></a></li>
            </ul>

            <h3>6. Cambios en nuestra política de cookies</h3>
            <p>
                Es posible que actualicemos esta política de cookies de vez en cuando. Cualquier cambio se reflejará en
                esta página, y te notificaremos si realizamos modificaciones significativas.


            </p>

            <h3>7. Contacto</h3>
            <p>
                Si tienes alguna duda sobre nuestra política de cookies, no dudes en contactar con nosotros a través de
                nuestra página de <a class="pointer" routerLink="/contact"><strong>contacto</strong></a>.
            </p>

        
        </div>
    </div>
</section>